import { incoTerms } from "constants/IncoTerms";
import {
    BringImportExport,
    DHLExport,
    DHLImport,
    DSVExportUK,
    FlightExport,
    FlightImport,
    UPSAccessPoint,
    UPSExport,
    UPSImport,
} from "./termsList";

export function getCustomsTermsOptions({
    carrier,
    product,
    fromCountryCode,
    toCountryCode,
}) {
    const GB_COUNTRY_CODES = ["GB-EN", "GB", "GB-SC", "GB-WA", "GB-NI"];

    if (GB_COUNTRY_CODES.includes(toCountryCode) && carrier === "DSV") {
        return DSVExportUK;
    }

    if (toCountryCode === "SE" && fromCountryCode !== "SE") {
        switch (carrier) {
            case "BRING":
                return BringImportExport;
            case "DHL":
                return DHLImport;
            case "UPS":
                return UPSImport;
            default:
                return FlightImport;
        }
    } else {
        switch (carrier) {
            case "BRING":
                return BringImportExport;
            case "DHL":
                return DHLExport;
            case "UPS": {
                if (product?.toUpperCase() === "ACCESS POINT") {
                    return UPSAccessPoint;
                }
                return UPSExport;
            }
            default:
                return FlightExport;
        }
    }
}

/**
 * Get customs terms option for VOEC
 *
 * @param {string} carrier
 * @param {string} product
 * @returns {Object} - Customs terms option
 */
export function getVoecCustomsTermsOption(carrier, product) {
    if (carrier === "UPS" && product === "Access Point") {
        return {
            title: incoTerms.ddp.description,
            value: incoTerms.ddp.code,
        };
    }
    if (carrier === "DHL" && product === "Parcel Connect") {
        return {
            title: incoTerms.dhl.ddp.description,
            value: incoTerms.dhl.ddp.code,
        };
    }

    return {
        title: incoTerms.dap.description,
        value: incoTerms.dap.code,
    };
}
